module.exports = ".side-menu-container .navbar-nav > li {\n  float: none !important; }\n\n.navbar-default {\n  background-color: transparent !important;\n  border-color: transparent !important; }\n\n.navbar {\n  margin: 0; }\n\n.left-menu {\n  background: #2A3A4A;\n  min-height: 800px;\n  padding: 20px;\n  margin-top: -20px;\n  margin-left: -17px;\n  padding-right: 40px; }\n\n.slide-in {\n  margin-top: -45px;\n  z-index: 9; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/left-menu/left-menu.component.scss
// module id = ./src/app/left-menu/left-menu.component.scss
// module chunks = main